// import external dependencies
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import 'picturefill';
import 'lazysizes';
import 'lazysizes/plugins/aspectratio/ls.aspectratio.js';

// loads the Icon plugin
UIkit.use(Icons);

// Import everything from autoload

//import formValidation from './vendors/formvalidation/core/Core'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import templateTourism from './routes/templateTourism';
import aboutUs from './routes/about';

//partials
import './partials/results';
import './partials/showMore';
import './partials/accordion';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Tourism
  templateTourism,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
routes.loadEvents();



// WEBPACK FOOTER //
// ./scripts/main.js